'use strict';

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var Store = require('orbit-db-store');

var EventIndex = require('./EventIndex'); // TODO: generalize the Iterator functions and spin to its own module


var EventStore = /*#__PURE__*/function (_Store) {
  _inherits(EventStore, _Store);

  var _super = _createSuper(EventStore);

  function EventStore(ipfs, id, dbname) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, EventStore);

    if (options.Index === undefined) Object.assign(options, {
      Index: EventIndex
    });
    _this = _super.call(this, ipfs, id, dbname, options);
    _this._type = 'eventlog';

    _this.events.on("log.op.ADD", function (address, hash, payload) {
      _this.events.emit("db.append", payload.value);
    });

    return _this;
  }

  _createClass(EventStore, [{
    key: "add",
    value: function add(data) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._addOperation({
        op: 'ADD',
        key: null,
        value: data
      }, options);
    }
  }, {
    key: "get",
    value: function get(hash) {
      return this.iterator({
        gte: hash,
        limit: 1
      }).collect()[0];
    }
  }, {
    key: "iterator",
    value: function iterator(options) {
      var _iterator;

      var messages = this._query(options);

      var currentIndex = 0;
      var iterator = (_iterator = {}, _defineProperty(_iterator, Symbol.iterator, function () {
        return this;
      }), _defineProperty(_iterator, "next", function next() {
        var item = {
          value: null,
          done: true
        };

        if (currentIndex < messages.length) {
          item = {
            value: messages[currentIndex],
            done: false
          };
          currentIndex++;
        }

        return item;
      }), _defineProperty(_iterator, "collect", function collect() {
        return messages;
      }), _iterator);
      return iterator;
    }
  }, {
    key: "_query",
    value: function _query(opts) {
      if (!opts) opts = {};
      var amount = opts.limit ? opts.limit > -1 ? opts.limit : this._index.get().length : 1; // Return 1 if no limit is provided

      var events = this._index.get().slice();

      var result = [];

      if (opts.gt || opts.gte) {
        // Greater than case
        result = this._read(events, opts.gt ? opts.gt : opts.gte, amount, !!opts.gte);
      } else {
        // Lower than and lastN case, search latest first by reversing the sequence
        result = this._read(events.reverse(), opts.lt ? opts.lt : opts.lte, amount, opts.lte || !opts.lt).reverse();
      }

      if (opts.reverse) {
        result.reverse();
      }

      return result;
    }
  }, {
    key: "_read",
    value: function _read(ops, hash, amount, inclusive) {
      // Find the index of the gt/lt hash, or start from the beginning of the array if not found
      var index = ops.map(function (e) {
        return e.hash;
      }).indexOf(hash);
      var startIndex = Math.max(index, 0); // If gte/lte is set, we include the given hash, if not, start from the next element

      startIndex += inclusive ? 0 : 1; // Slice the array to its requested size

      var res = ops.slice(startIndex).slice(0, amount);
      return res;
    }
  }]);

  return EventStore;
}(Store);

module.exports = EventStore;